import {
  BasketColumnKeys,
  BasketGroupSortType,
} from 'graphql-api/baskets-api-interfaces';

import { ColKeysToSorting, SortingToColKeys } from './basket-column-keys.types';

export const sortByColumnKeyMap: ColKeysToSorting = {
  [BasketColumnKeys.DeliveryDate]: BasketGroupSortType.Delivery,
  [BasketColumnKeys.Markup]: BasketGroupSortType.Markup,
  [BasketColumnKeys.Quantity]: BasketGroupSortType.Quantity,
  [BasketColumnKeys.Rrp]: BasketGroupSortType.Rrp,
  [BasketColumnKeys.Wsp]: BasketGroupSortType.Wsp,
  [BasketColumnKeys.Value]: BasketGroupSortType.TotalWsp,
  [BasketColumnKeys.ValueNet]: BasketGroupSortType.TotalNet,
  [BasketColumnKeys.ValueRrp]: BasketGroupSortType.TotalRrp,
  [BasketColumnKeys.Net]: BasketGroupSortType.TotalRrp,
  [BasketColumnKeys.CreatedDate]: BasketGroupSortType.CreatedDate,
  [BasketColumnKeys.ProductId]: BasketGroupSortType.ProductId,
  [BasketColumnKeys.Gender]: BasketGroupSortType.Gender,
};

export const columnKeyBySortMap: SortingToColKeys = {
  [BasketGroupSortType.Delivery]: BasketColumnKeys.DeliveryDate,
  [BasketGroupSortType.Markup]: BasketColumnKeys.Markup,
  [BasketGroupSortType.Quantity]: BasketColumnKeys.Quantity,
  [BasketGroupSortType.Rrp]: BasketColumnKeys.Rrp,
  [BasketGroupSortType.Wsp]: BasketColumnKeys.Wsp,
  [BasketGroupSortType.TotalWsp]: BasketColumnKeys.Value,
  [BasketGroupSortType.TotalRrp]: BasketColumnKeys.ValueRrp,
  [BasketGroupSortType.ProductId]: BasketColumnKeys.ProductId,
  [BasketGroupSortType.Gender]: BasketColumnKeys.Gender,
};
